import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { LayoutDashboard, Layers, Settings, ChevronLeft, ChevronRight, Map } from 'lucide-react'

function Sidebar() {
  const [collapsed, setCollapsed] = useState(false)

  const navItems = [
    { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/layers', icon: Layers, label: 'Map Layers' },
    { to: '/settings', icon: Settings, label: 'Settings' },
  ]

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <Map size={24} />
        <h1>InteractPI</h1>
        <button
          className="sidebar-toggle"
          onClick={() => setCollapsed(!collapsed)}
          style={{ marginLeft: 'auto' }}
        >
          {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>
      </div>
      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            <item.icon size={20} />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  )
}

export default Sidebar
